import { BaseEntity } from "./base-entity";

export interface Locality extends BaseEntity {
  name: string;
  displayName: string;
  postalCode: string;
}
export namespace Locality {

  export function equals(locality1: Locality, locality2: Locality): boolean {
    return locality1 && locality2
      ? locality1.name === locality2.name
      : locality1 === locality2;
  }
}
